module.exports = __webpack_public_path__ + "static/img/four.f6e63f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-five/four.png
// module id = 4adg
// module chunks = 0